module.exports = __webpack_public_path__ + "static/media/gyrocopter.ac349626.png";